const routes = [
  {
    path: 'zero-width-injector',
    name: 'zero-width-injector',
    component: () => import(/* webpackChunkName: "zero-width-injector" */ '@/modules/zero-width-injector/index.vue')
  },
];

export default routes;